<template>
  <div
    class="my-2 mb-4 h-1 w-20 rounded-full lg:mb-6 lg:w-60"
    :class="'bg-' + color"
  ></div>
</template>

<script setup lang="ts">
defineProps({
  color: {
    type: String,
    required: true,
  },
});
</script>
